var _g, _g2, _g3, _g4, _g5, _g6, _g7, _path, _g8, _g9, _path2, _g10, _g11, _path3, _path4, _g12, _circle, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 626,
    height: 651,
    viewBox: "0 0 626 651",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4001_49593)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4001_49593)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 176.5,
    cy: 164.5,
    r: 189.5,
    fill: "url(#paint0_linear_4001_49593)",
    fillOpacity: 0.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_4001_49593)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 196.5,
    cy: 164.5,
    r: 189.5,
    fill: "url(#paint1_linear_4001_49593)",
    fillOpacity: 0.3
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_4001_49593)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 496.5,
    cy: 164.5,
    r: 189.5,
    fill: "url(#paint2_linear_4001_49593)",
    fillOpacity: 0.3
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_4001_49593)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 521.5,
    cy: 143.5,
    r: 189.5,
    fill: "url(#paint3_linear_4001_49593)",
    fillOpacity: 0.3
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_4001_49593)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 426.5,
    cy: 544.5,
    r: 189.5,
    fill: "url(#paint4_linear_4001_49593)",
    fillOpacity: 0.3
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_4001_49593)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 489,
    r: 215,
    fill: "url(#paint5_linear_4001_49593)",
    fillOpacity: 0.3
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_4001_49593)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4001_49593)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 244,
    width: 230,
    height: 141,
    rx: 12.8889,
    fill: "white",
    fillOpacity: 0.3,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_4001_49593)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.668,
    y: 293.465,
    width: 178.511,
    height: 7.73333,
    rx: 3.86667,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_4001_49593)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.668,
    y: 308.93,
    width: 115,
    height: 6,
    rx: 3,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_4001_49593)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 59.668,
    y1: 331.006,
    x2: 238.179,
    y2: 331.006,
    stroke: "white",
    strokeWidth: 0.878788
  })), /*#__PURE__*/React.createElement("rect", {
    x: 141.922,
    y: 252,
    width: 14.0606,
    height: 14.0606,
    rx: 7.0303,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 243,
    width: 232,
    height: 143,
    rx: 13.8889,
    stroke: "white",
    strokeWidth: 2,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 401.548C21 400.693 21.6932 400 22.5484 400H275.452C276.307 400 277 400.693 277 401.548C277 405.112 274.112 408 270.548 408H27.4516C23.8885 408 21 405.112 21 401.548Z",
    fill: "#FFC6D1"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_4001_49593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264 400H34C34 395.582 37.5817 392 42 392H256C260.418 392 264 395.582 264 400Z",
    fill: "#FFC6D1"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_4001_49593)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 362,
    y: 244,
    width: 230,
    height: 141,
    rx: 12.8889,
    fill: "white",
    fillOpacity: 0.3,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361,
    y: 243,
    width: 232,
    height: 143,
    rx: 13.8889,
    stroke: "white",
    strokeWidth: 2,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.718 304.863C497.177 306.927 496.993 308.956 495.495 312.483L493.163 317.801L488.39 304.863H482.566L490.155 325.102H495.837L500.856 313.673C502.38 310.035 502.641 307.165 502.178 304.863H496.718Z",
    fill: "url(#paint6_linear_4001_49593)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.797 307.187C520.861 305.14 518.411 304.118 515.445 304.121C512.451 304.121 509.987 305.145 508.051 307.192C506.116 309.239 505.148 311.843 505.148 315.004C505.148 318.112 506.123 320.696 508.073 322.757C510.022 324.817 512.48 325.848 515.445 325.849C518.411 325.849 520.868 324.818 522.818 322.757C524.74 320.696 525.7 318.112 525.7 315.004C525.7 311.841 524.732 309.235 522.797 307.187ZM518.802 318.881C517.881 319.955 516.762 320.492 515.445 320.492C514.127 320.492 513.015 319.955 512.109 318.881C511.176 317.807 510.709 316.514 510.708 315.002C510.708 313.463 511.161 312.15 512.067 311.06C512.973 309.971 514.099 309.425 515.445 309.423C516.79 309.423 517.916 309.969 518.822 311.06C519.729 312.152 520.182 313.466 520.181 315.002C520.181 316.514 519.722 317.807 518.802 318.881Z",
    fill: "url(#paint7_linear_4001_49593)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.927 315.328V312.656C456.927 307.17 454.508 304.427 449.671 304.426C447.617 304.426 445.528 305.142 443.404 306.574C442.193 305.141 440.352 304.424 437.882 304.422C436.089 304.422 434.271 304.966 432.428 306.055C431.478 306.61 430.409 306.899 429.323 306.895H427.871V325.103H433.355V310.798C434.733 310.016 435.919 309.625 436.914 309.624C437.72 309.624 438.392 309.873 438.931 310.37C439.469 310.867 439.738 311.557 439.738 312.439V325.103H445.141V312.656C445.142 312.055 445.109 311.455 445.042 310.859C446.462 310.039 447.681 309.629 448.7 309.629C449.506 309.629 450.178 309.877 450.716 310.374C451.254 310.871 451.523 311.561 451.523 312.443V325.103H456.937V315.324L456.927 315.328Z",
    fill: "url(#paint8_linear_4001_49593)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.2 318.797L479.047 318.931C477.41 320.366 474.318 321.581 471.003 320.287C469.972 319.856 469.083 319.023 468.467 317.928C470.961 318.65 473.671 318.544 475.729 317.64C476.768 317.209 477.702 316.539 478.464 315.677C480.252 313.648 480.706 310.742 479.618 308.273C479.328 307.608 478.932 307 478.448 306.476C477.259 305.2 475.578 304.38 473.714 304.169C470.61 303.815 467.28 305.29 464.976 308.041C464.557 307.15 464.256 306.2 464.084 305.221L464.062 305.094H459.301L459.322 305.267C459.695 308.291 460.999 311.29 462.909 313.51L462.9 313.553C462.509 318.532 465.14 323.216 469.3 324.943L469.34 324.96C470.337 325.353 471.375 325.617 472.433 325.747C472.92 325.805 473.41 325.834 473.9 325.833C476.407 325.833 478.86 325.066 480.965 323.625L481.067 323.555L479.2 318.797ZM468.204 312.418C468.95 310.381 471.034 308.884 473.014 308.986C473.674 309.022 474.563 309.315 474.903 310.026C475.048 310.351 475.106 310.712 475.07 311.069C475.035 311.426 474.907 311.766 474.701 312.052C474.47 312.372 474.173 312.631 473.832 312.811L473.786 312.837C472.847 313.367 471.312 313.501 469.965 313.17C469.345 313.016 468.751 312.761 468.204 312.415V312.418Z",
    fill: "url(#paint9_linear_4001_49593)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.922,
    y: 252,
    width: 14.0606,
    height: 14.0606,
    rx: 7.0303,
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M349 401.548C349 400.693 349.693 400 350.548 400H603.452C604.307 400 605 400.693 605 401.548C605 405.112 602.112 408 598.548 408H355.452C351.888 408 349 405.112 349 401.548Z",
    fill: "#DAB2FF"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_4001_49593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M592 400H362C362 395.582 365.582 392 370 392H584C588.418 392 592 395.582 592 400Z",
    fill: "#E9D4FF"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276 337H264C262.895 337 262 337.895 262 339V347C262 348.105 262.895 349 264 349H276C277.105 349 278 348.105 278 347V339C278 337.895 277.105 337 276 337Z",
    fill: "#EEF1FF",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266 341H274M266 343H272M266 345H270",
    stroke: "#3D0E6B",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M283 263H271C269.895 263 269 263.895 269 265V273C269 274.105 269.895 275 271 275H283C284.105 275 285 274.105 285 273V265C285 263.895 284.105 263 283 263Z",
    fill: "#C8D3FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M273 267H281M273 269H279M273 271H277",
    stroke: "#3D0E6B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 260,
    y: 311,
    width: 106,
    height: 12
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_6_4001_49593_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 4
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_4001_49593)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 315,
    width: 98,
    height: 4,
    rx: 2,
    fill: "white",
    fillOpacity: 0.6
  })))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 283.521,
    y: 285.525,
    width: 58.9493,
    height: 58.9493
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.74px)",
      clipPath: "url(#bgblur_7_4001_49593_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-figma-bg-blur-radius": 5.47465,
    cx: 312.996,
    cy: 315,
    r: 24,
    fill: "white",
    fillOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M315.181 308L321.969 314.788M321.969 314.788L315.181 321.576M321.969 314.788H304.999",
    stroke: "#3D0E6B",
    strokeWidth: 2.30388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M366 317H356C354.895 317 354 317.895 354 319V325C354 326.105 354.895 327 356 327H366C367.105 327 368 326.105 368 325V319C368 317.895 367.105 317 366 317Z",
    fill: "#FFB6BF",
    fillOpacity: 0.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M357 321H365M357 323H362",
    stroke: "#3D0E6B",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4001_49593",
    x: -113,
    y: -125,
    width: 579,
    height: 579,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_4001_49593"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4001_49593",
    x: -93,
    y: -125,
    width: 579,
    height: 579,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_4001_49593"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_4001_49593",
    x: 207,
    y: -125,
    width: 579,
    height: 579,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_4001_49593"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_4001_49593",
    x: 232,
    y: -146,
    width: 579,
    height: 579,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_4001_49593"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_4001_49593",
    x: 137,
    y: 255,
    width: 579,
    height: 579,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_4001_49593"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_4001_49593",
    x: -159.456,
    y: 160.544,
    width: 656.913,
    height: 656.913,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 56.7282,
    result: "effect1_foregroundBlur_4001_49593"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_4001_49593",
    x: 28,
    y: 242,
    width: 242,
    height: 153,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4001_49593"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "BackgroundImageFix",
    in2: "effect1_dropShadow_4001_49593",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_4001_49593",
    x: 30,
    y: 392,
    width: 238,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4001_49593"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4001_49593",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_4001_49593",
    x: 356,
    y: 242,
    width: 242,
    height: 153,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4001_49593"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "BackgroundImageFix",
    in2: "effect1_dropShadow_4001_49593",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_4001_49593",
    x: 358,
    y: 392,
    width: 238,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4001_49593"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4001_49593",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_6_4001_49593_clip_path",
    transform: "translate(-260 -311)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 315,
    width: 98,
    height: 4,
    rx: 2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_7_4001_49593_clip_path",
    transform: "translate(-283.521 -285.525)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 312.996,
    cy: 315,
    r: 24
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4001_49593",
    x1: 146.891,
    y1: -239.528,
    x2: 146.891,
    y2: 493.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D0E6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4001_49593",
    x1: 166.891,
    y1: -239.528,
    x2: 166.891,
    y2: 493.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC3CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9C0C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4001_49593",
    x1: 466.891,
    y1: -239.528,
    x2: 466.891,
    y2: 493.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9BCC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4001_49593",
    x1: 491.891,
    y1: -260.528,
    x2: 491.891,
    y2: 472.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9BCC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4001_49593",
    x1: 396.891,
    y1: 140.472,
    x2: 396.891,
    y2: 873.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9BCC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4001_49593",
    x1: 135.406,
    y1: 30.6038,
    x2: 135.406,
    y2: 862.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9BCC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4001_49593",
    x1: 490.927,
    y1: 293.407,
    x2: 490.927,
    y2: 332.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D0E6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C16C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4001_49593",
    x1: 513.819,
    y1: 291.822,
    x2: 513.819,
    y2: 333.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D0E6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C16C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4001_49593",
    x1: 440.133,
    y1: 292.716,
    x2: 440.133,
    y2: 332.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D0E6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C16C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4001_49593",
    x1: 468.484,
    y1: 291.825,
    x2: 468.484,
    y2: 333.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D0E6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C16C0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4001_49593"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 626,
    height: 651,
    rx: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4001_49593"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 244,
    width: 230,
    height: 141,
    rx: 12.8889,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_4001_49593"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.668,
    y: 293.465,
    width: 178.511,
    height: 7.73333,
    rx: 3.86667,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_4001_49593"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.668,
    y: 308.93,
    width: 115,
    height: 6,
    rx: 3,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_4001_49593"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 178.511,
    height: 7.03036,
    fill: "white",
    transform: "translate(59.668 327.93)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_4001_49593"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 315,
    width: 98,
    height: 4,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportData);
export default __webpack_public_path__ + "static/media/import-data.bc690ec527044525eef4ae94a8b31ebc.svg";
export { ForwardRef as ReactComponent };